module.exports = __webpack_public_path__ + "static/media/img-modal-nro-cliente.1da1d325.jpeg";